import { compose } from 'recompose'

import { withFlowRouter } from 'utils/FlowProvider'

export const enhance = compose<{}, {}>(withFlowRouter)
